import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import '../Grid.less';
import { setRightMenuOpen } from '@redux/slices/global';
import { IRootSlice } from '@typings/rootSlice';
import cn from 'classnames';
import React, { FC, ReactNode } from 'react';

interface IProps {
    children?: ReactNode;
    className?: string;
}

const RightColumn: FC<IProps> = ({ children = null, className = '' }) => {
    const dispatch = useAppDispatch();
    const rightMenuOpen = useAppSelector((state: IRootSlice) => state.globalSlice.rightMenuOpen);
    const clName = cn('grid__right-column', {
        open: rightMenuOpen,
        [className]: className,
    });
    const closeRightMenu = () => dispatch(setRightMenuOpen(false));

    return (
        <div className={clName}>
            <div className="grid__sticky">
                <div className="grid__right-column__inner">{children}</div>
            </div>
            <div className="grid__right-column__overlay" onClick={() => closeRightMenu?.()} />
        </div>
    );
};

export default RightColumn;
